export class ActionTypeQueryParameters {
  id?: string;
  page?: number;
  pageSize?: number;

  constructor(obj?: any) {
    if (obj) Object.assign(this, obj);
  }
}
